export const SAVE_MPH_DISCOUNT_CODE = 'Profile/SAVE_MPH_DISCOUNT_CODE';
export const CLEAR_MPH_DISCOUNT_CODE = 'Profile/CLEAR_MPH_DISCOUNT_CODE';
export const REQUEST_PROFILE_DATA_PENDING = 'Profile/REQUEST_PROFILE_DATA_PENDING';
export const REQUEST_PROFILE_DATA_SUCCESS = 'Profile/REQUEST_PROFILE_DATA_SUCCESS';
export const REQUEST_PROFILE_DATA_FAILURE = 'Profile/REQUEST_PROFILE_DATA_FAILURE';
export const CLEAR_PROFILE_DATA = 'Profile/CLEAR_PROFILE_DATA';
